import PropTypes from "prop-types"

import _ from "lodash"

import React, { useState, useEffect } from "react"

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, Redirect, useParams, useLocation } from "react-router-dom"

import withRouter from "components/Common/withRouter"

import Select from "react-select"

import { getSession, logout } from "helpers/AuthType/authService"

import { Birthdate } from "components/Common/DatePicker"

// Formik validation
import { useFormik } from "formik"

import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
// actions
import {
  loginConsole,
  loginUser,
  loginCoUser,
} from "store/actions"

//Import SelectWithValidation
import Toastr from "components/Common/toastr"

//Global Functions
import { findElementPositionById, regexp } from "common/global/functions.js"

// Modals
//import Modals from "../Modals";

const PlaceHolder = props => {
  //meta title
  document.title = "Loading Information | Equity Sales Finance, INC."

  const dispatch = useDispatch()
  const params = useParams()
  const location = useLocation();

  const [redirect, setRedirect] = useState(true)
  const [routes, setRoutes] = useState(location.hasOwnProperty('pathname') ? _.split(location.pathname, '/') : [])

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    error: login.error,
    loading: login.loading,
    authenticated: login.authenticated,
    response: login.response,
    isUserLogout : login.isUserLogout
  }))

  const { error, isUserLogout, authenticated, response, loading } = useSelector(LoginProperties)

  useEffect(() => {
    if (error) {
      setErrorResponse(error)
      setErrorPopupModal(true)
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    } else if (authenticated && response && (routes).includes('console')) {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
      //props.router.navigate("/dashboard")
      window.location.assign("/dashboard")
    } else if (authenticated && response && (routes).includes('sign-up') && (routes).includes('co')) {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
      //props.router.navigate("/landing-page")
      window.location.assign("/co/landing-page")
    } else if (authenticated && response && (routes).includes('sign-up')) {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
      //props.router.navigate("/landing-page")
      window.location.assign("/landing-page")
    }
  }, [error, authenticated, response])

  useEffect(() => {   
    if (redirect && params.code && params.pin) {
      dispatch(loginConsole(params, props.router.navigate))
    }else if(redirect && params.identifier && params.coapplicant){
      dispatch(loginCoUser(params, props.router.navigate))
    }else if(redirect && params.identifier){
      dispatch(loginUser(params, props.router.navigate))
    }
    setRedirect(false);
  }, [redirect])

  const [errorPopupModal, setErrorPopupModal] = useState(false)
  const [activeTab, setactiveTab] = useState(0)
  const [errorResponse, setErrorResponse] = useState(false)
 
  const onErrorPopUpSubmit = event => {
    if (params.code && params.pin) {
      window.location.assign("https://www.equitysalesfinance.com/portal/dealer")
    }else{
      props.router.navigate("/");
    }
  }

  const onSignUpErrorPopUpSubmit = event => {
  }

  return (
    <React.Fragment>

      {/* Start Error Modal */}
      <Modal
        isOpen={errorPopupModal}
        backdrop={"static"}
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Processing Request Error
          </h5>
        </div>
        <div className="modal-body">
          {errorResponse ? <Alert color="danger">{errorResponse}</Alert> : null}
        </div>
        {errorPopupModal && <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              onErrorPopUpSubmit()
            }}
            className="btn btn-primary "
            data-dismiss="modal"
          >
            Close
          </button>        
        </div>
        }
      </Modal>

      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={""} breadcrumbItem={""} />
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-4"></CardTitle>

                <div className="wizard clearfix">
                  <div className="steps clearfix">
                    <ul>
                      <NavItem className={"card-title placeholder-glow"}>
                        <NavLink
                          className={"placeholder col-12"}
                          disabled={true}
                        >
                          <span className="number">1.</span> &nbsp;
                        </NavLink>
                      </NavItem>
                      <NavItem className={"card-title placeholder-glow"}>
                        <NavLink
                          className={"placeholder col-12"}
                          disabled={true}
                        >
                          <span className="number">2.</span> &nbsp;
                        </NavLink>
                      </NavItem>
                      <NavItem className={"card-title placeholder-glow"}>
                        <NavLink
                          className={"placeholder col-12"}
                          disabled={true}
                        >
                          <span className="number">3.</span> &nbsp;
                        </NavLink>
                      </NavItem>
                      <NavItem className={"card-title placeholder-glow"}>
                        <NavLink
                          className={"placeholder col-12"}
                          disabled={true}
                        >
                          <span className="number">4.</span> &nbsp;
                        </NavLink>
                      </NavItem>
                    </ul>
                  </div>
                  {/* End Wizard Steps */}
                  <div className="content clearfix">
                    <TabContent activeTab={activeTab} className="body">
                      <TabPane tabId={0}>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="12">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                          <Col lg="4">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3 card-title placeholder-glow">
                              <Label>&nbsp;</Label>
                              <Input
                                type="text"
                                placeholder=""
                                disabled={true}
                                className={"placeholder col-12"}
                              />
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </div>

                  <div className="actions clearfix">
                    <ul>
                      <li className={"previous card-title placeholder-glow"}>
                        <Link
                          to="#"
                          className="btn btn-info btn-block disabled placeholder col-12"
                        >
                          Previous
                        </Link>
                      </li>

                      <li className={"next card-title placeholder-glow"}>
                        <Link
                          to="#"
                          className="btn btn-primary disabled placeholder col-12"
                        >
                          Next
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(PlaceHolder)

PlaceHolder.propTypes = {
  history: PropTypes.object,
}
